import { Button, Dialog, RadioButton } from 'lynkco-up-core';
import { useEffect, useState } from 'react';
import ManagementTable from '../../parts/UpdateManagement/ManagementTable';
import { Layout, PostApplication, PostVersion, PutManagementBody, UpdateApplications, UpdateVersions } from './types';
import {
  ChangeVersionForm,
  CreateApplicationForm,
  CreateVersionForm,
  DeleteVersionForm,
} from '../../parts/UpdateManagement';
import { getApplication, updateVersion, saveVersion, deleteVersion, saveApplication } from './managementMethods';

type VersionsProp = {
  filteredModel: string;
};

function ManagementPage({ filteredModel }: VersionsProp) {
  const [showOnlyActive, setShowOnlyActive] = useState<boolean>(true);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [versionsObject, setVersionsObject] = useState<UpdateVersions | undefined>();
  const [appsObject, setappsObject] = useState<UpdateApplications | undefined>();
  const [IsNewCar, setIsNewCar] = useState<boolean>(false);
  const [applications, setApplications] = useState<UpdateApplications[] | undefined>();
  const [layout, setLayout] = useState<string>('updateVersion');

  const dialogCommponents: Layout = {
    updateVersion: {
      header: 'Change version information',
      icon: 'edit_note',
      compontent: <ChangeVersionForm versionsObject={versionsObject} setVersionsObject={setVersionsObject} />,
      method: 'Put-version',
      confirmText: 'Change',
    },
    createVersion: {
      header: 'Add new version',
      icon: 'post_add',
      compontent: (
        <CreateVersionForm
          versionsObject={versionsObject}
          setVersionsObject={setVersionsObject}
          applications={applications}
          filteredModel={filteredModel}
        />
      ),
      method: 'Post-version',
      confirmText: 'Add',
    },
    deleteVersion: {
      header: 'Delete version',
      icon: 'delete',
      compontent: <DeleteVersionForm versionsObject={versionsObject} />,
      method: 'Delete-version',
      confirmText: 'Delete',
    },
    createApplication: {
      header: 'Add new application',
      icon: 'post_add',
      compontent: (
        <CreateApplicationForm appsObject={appsObject} setappsObject={setappsObject} setIsNewCar={setIsNewCar} />
      ),
      method: 'Post-application',
      confirmText: 'Add app',
    },
  };

  async function submit(method: string) {
    if (method === 'Put-version' && versionsObject?.id && applications) {
      const reqBody: PutManagementBody = {
        id: versionsObject.id,
        applicationId: applications.find(e => e.packageName === versionsObject.packageName)?.id || '',
        version: versionsObject.version,
        status: versionsObject.status,
        releaseNote: versionsObject.releaseNote,
        vehicleModels: filteredModel.split(','),
      };
      const responce = await updateVersion(reqBody);
      if (responce !== undefined) {
        setIsUpdating(true);
        closeDialog();
      }
    } else if (method === 'Post-version' && versionsObject && applications) {
      const regexVersion = /^(\d+[-.]){2,3}\d+$/g;
      const isValidVersion = regexVersion.test(versionsObject.version.trim());
      const reqBody: PostVersion = {
        applicationId: applications.find(e => e.packageName === versionsObject.packageName)?.id || '',
        version: isValidVersion ? versionsObject.version.trim() : '',
        releaseNote: versionsObject.releaseNote?.trim() || '',
        status: versionsObject.status,
        vehicleModels: filteredModel.split(','),
      };
      if (reqBody.version !== '') {
        const responce = await saveVersion(reqBody);
        if (responce !== undefined) {
          setIsUpdating(true);
          closeDialog();
        }
      }
    } else if (method === 'Delete-version' && versionsObject?.id) {
      const responce = await deleteVersion(versionsObject.id);
      if (responce !== undefined) {
        setIsUpdating(true);
        closeDialog();
      }
    } else if (method === 'Post-application' && appsObject) {
      const reqBody: PostApplication = {
        name: appsObject.name + (appsObject.name !== '' && IsNewCar ? ' NV' : ''),
        packageName: appsObject.packageName,
      };
      const responce = await saveApplication(reqBody);
      if (responce !== undefined) {
        setIsUpdating(true);
        closeDialog();
      }
    }
  }

  function closeDialog() {
    setShowDialog(false);
  }

  function openDialog(display: string, versionsObject?: UpdateVersions) {
    setVersionsObject(versionsObject);
    setLayout(display);
    setShowDialog(true);
  }

  async function fetchApps() {
    try {
      const responseData = await getApplication();
      setApplications(responseData.content);
    } catch (error) {
      console.error('Error occurred while fetching management updates: ', error);
    }
  }

  useEffect(() => {
    fetchApps();
  }, [isUpdating]);

  useEffect(() => {
    fetchApps();
  }, []);

  return (
    <article className="mt-6 mx-4">
      <div className="flex justify-between items-baseline">
        <div className="flex flex-col gap-1.5 my-2.5 -ml-1.5">
          <RadioButton
            value="Show only active versions"
            name="Show version"
            labelText="Show only active versions"
            onChange={() => setShowOnlyActive(true)}
            defaultChecked={true}
            isChecked={showOnlyActive}
          />
          <RadioButton
            value="Show all"
            name="Show version"
            labelText="Show all"
            onChange={() => setShowOnlyActive(false)}
            isChecked={!showOnlyActive}
          />
        </div>
        <div className="flex gap-1">
          <Button variant="white" onClick={() => openDialog('createApplication')}>
            Add Application
          </Button>
          <Button variant="white" onClick={() => openDialog('createVersion')}>
            Add Version
          </Button>
        </div>
      </div>
      <ManagementTable
        isUpdating={isUpdating}
        setIsUpdating={setIsUpdating}
        filteredModel={filteredModel}
        showOnlyActive={showOnlyActive}
        openDialog={openDialog}
      />
      <Dialog
        onCancel={closeDialog}
        onConfirm={() => submit(dialogCommponents[layout].method)}
        confirmText={dialogCommponents[layout].confirmText}
        cancelText="Cancel"
        isOpen={showDialog}
        icon={dialogCommponents[layout].icon}
        title={dialogCommponents[layout].header}>
        {dialogCommponents[layout].compontent}
      </Dialog>
    </article>
  );
}

export default ManagementPage;
